import camelize from 'camelcase-keys-deep';

export default class LegalEntityFile {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
